module.exports = __webpack_public_path__ + "static/howto-4-4154a9491486f0e108fbd5808ba605c1.png";